import { twMerge } from "tailwind-merge";

type Props = {
  name: string;
  label?: string;
  checked?: boolean;
  labelClassName?: string;
  inputClassName?: string;
  onCheck?: () => void;
};

const RadioButton = ({
  name,
  label = "",
  checked = true,
  labelClassName = "",
  inputClassName = "",
  onCheck = () => {}
}: Props) => {
  return (
    <div className="inline-flex items-center">
      <input
        id={`${name}-radio`}
        name={name}
        type="radio"
        className={twMerge(
          "peer h-4 w-4 cursor-pointer rounded-full border border-slate-300 accent-teal-500 checked:border-teal-500 transition-all",
          inputClassName
        )}
        checked={checked}
        onClick={() => onCheck?.()}
        onChange={() => {}}
      />
      {label && (
        <label
          data-testid="radio-label"
          htmlFor={`${name}-radio`}
          className={twMerge(
            "ml-2 text-txtPlaceholder cursor-pointer font-bold",
            labelClassName
          )}
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default RadioButton;
